module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goods"
  }, [_c('div', {
    ref: "menuWrapper",
    staticClass: "menu-wrapper"
  }, [_c('ul', _vm._l((_vm.goods), function(item, index) {
    return _c('li', {
      staticClass: "menu-item",
      class: {
        'current': _vm.currentIndex === index
      },
      on: {
        "click": function($event) {
          _vm.selectMenu(index, $event)
        }
      }
    }, [_c('span', {
      staticClass: "text border-1px"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type > 0),
        expression: "item.type>0"
      }],
      staticClass: "icon",
      class: _vm.classMap[item.type]
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))])])])
  }))]), _vm._v(" "), _c('div', {
    ref: "foodWrapper",
    staticClass: "foods-wrapper"
  }, [_c('ul', _vm._l((_vm.goods), function(item) {
    return _c('li', {
      staticClass: "food-list food-list-hook"
    }, [_c('h1', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('ul', _vm._l((item.foods), function(food) {
      return _c('li', {
        staticClass: "food-item border-1px",
        on: {
          "click": function($event) {
            _vm.seeFood(food, $event)
          }
        }
      }, [_c('div', {
        staticClass: "img-icon"
      }, [_c('img', {
        attrs: {
          "src": food.icon,
          "width": "64",
          "height": "64"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "content"
      }, [_c('span', {
        staticClass: "name"
      }, [_vm._v(_vm._s(food.name))]), _vm._v(" "), (food.remark) ? _c('span', {
        staticClass: "remark"
      }, [_vm._v("(" + _vm._s(food.remark) + ")")]) : _vm._e(), _vm._v(" "), (food.description) ? _c('div', {
        staticClass: "describe"
      }, [_c('p', {
        staticClass: "desc"
      }, [_vm._v(_vm._s(food.description))])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "extra"
      }, [_c('span', {
        staticClass: "count"
      }, [_vm._v("月售" + _vm._s(food.sellCount))]), _c('span', [_vm._v("好评率" + _vm._s(food.rating) + "%")])]), _vm._v(" "), _c('div', {
        staticClass: "price"
      }, [_c('span', {
        staticClass: "now"
      }, [_c('span', {
        staticClass: "icon-font"
      }, [_vm._v("￥")]), _vm._v(_vm._s(food.price))]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (food.oldPrice),
          expression: "food.oldPrice"
        }],
        staticClass: "old"
      }, [_vm._v("￥" + _vm._s(food.oldPrice))])]), _vm._v(" "), _c('div', {
        staticClass: "cartcontrol-wrapper"
      }, [_c('cartcontrol', {
        attrs: {
          "food": food
        },
        on: {
          "add": _vm.addFood
        }
      })], 1)])])
    }))])
  }))]), _vm._v(" "), _c('shopcart', {
    ref: "shopcart",
    attrs: {
      "delivery-price": _vm.seller.deliveryPrice,
      "min-price": _vm.seller.minPrice,
      "select-foods": _vm.selectFoods
    }
  }), _vm._v(" "), _c('food', {
    ref: "food",
    attrs: {
      "food": _vm.seeFoodinfo
    },
    on: {
      "add": _vm.addFood
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b44062b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/goods/goods.vue
// module id = 53
// module chunks = 0